import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export async function convertFileBytesToBase64(fileBytes: Uint8Array): Promise<string> {
    return new Promise((resolve, reject) => {
        const blob = new Blob([fileBytes]);
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64data = reader.result;

            if (typeof base64data === 'string') {
                const base64String = base64data.split(',')[1];
                resolve(base64String);
            } else {
                reject(new Error('Failed to convert file to base64 string'));
            }
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(blob);
    });
}

export async function downloadFileById(fileId: string): Promise<any> {
    try {
        return await apiClient.get<any>(
            `${BASE_URL}/api/v1/file/download/${fileId}`,
            {
                responseType: "blob"
                // headers: {
                //     Authorization: `Bearer ${token}`,
                // }
            }
        )
    } catch (error) {
        console.error("Error fetching file download:", error);
        throw error;
    }
}
